import React, { useContext, useState, useEffect } from 'react';
import { StateStore } from '../store';
import './Registration.scss';
import { signed } from '../Actions/UserActions';
import Loading from './Loading';
import LocationSelect from './LocationSelect';
import OptionSwitch from './optionSwitch';
import SignModule from './SignModule';
import fire from '../base';
import firebase from 'firebase';

export const options = [
  "Shia Ithna-Ansari",
  "University of Islamic Sciences, Karachi",
  "Islamic Society of North America",
  "Muslim World League",
  "Umm Al-Qura University, Makkah",
  "Egyptian General Authority of Survey",
  "Institute of Geophysics, University of Tehran",
  "Gulf Region",
  "Kuwait",
  "Qatar",
  "Majlis Ugama Islam Singapura, Singapore",
  "Union Organization islamic de France",
  "Diyanet İşleri Başkanlığı, Turkey",
  "Spiritual Administration of Muslims of Russia"]

export default function Registration() {

  const { dispatch, state } = useContext(StateStore);
  const { preferences, hasInitialised } = state;
  const location = preferences?.location || null;

  const [formState, setFormState] = useState({ location });
  const [AuthType, setAuthType] = useState("SignIn");
  const [error, setError] = useState(hasInitialised ? { message: 'Update: This App has been connected to a database (finally). To continue, please SIGNUP. The data on your device will be merged into the new account and synced with the database.' } : null);
  const [isLoading, setLoading] = useState(false);

  const formUpdated = ({ target }) => {
    setFormState({ ...formState, [target.name]: target.value });
  }

  const onSubmit = e => {
    e.preventDefault();
    setLoading(true);
    const { password, email, location } = formState;
    if (AuthType === 'SignIn') signin(email, password)
    else if (AuthType === 'SignUp') signup(email, password, location)
  }
  //ask from databse if he has initialised? continue : send defaults info or local data if available
  const onSigned = async (creds) => {
    await signed(dispatch, creds, formState.location);
    setLoading(false);
  };

  const onError = err => {
    setError(err);
    setLoading(false);
  }

  useEffect(() => {
    // setError(null);
    if (AuthType === 'Google') {
      setLoading(true);
      let provider = new firebase.auth.GoogleAuthProvider();
      fire.auth().signInWithPopup(provider).then(onSigned).catch(onError);
    }
  }, [AuthType]);

  const signin = (email, password, location) => {
    fire.auth().signInWithEmailAndPassword(email, password).then(onSigned).catch(onError);
  }

  const signup = (email, password, location) => {
    if (email && password && location && location.city) {
      fire.auth().createUserWithEmailAndPassword(email, password).then(onSigned).catch(onError);
    } else {
      onError({ message: "Please fill all the fields" });
    }
  }

  return (
    <div className="register-container">
      <div className="card register-card">
        <div className="heading">
          Hey there!<br></br>
        </div>
        <OptionSwitch onChange={setAuthType} options={['SignUp', 'Google', 'SignIn',]}></OptionSwitch>
        {
          error ? <div className="error">{error.message}</div> : null
          // error ? <div className="error">{error.message} {hasInitialised ? (<>Use local data? <input type="checkbox" onChange={formUpdated} checked name="useLocal" id="" /></>):null}</div> : null
        }
        {
          (AuthType === 'SignUp' || AuthType === 'SignIn') ?
            <form onSubmit={onSubmit} className="sign-modules">
              <SignModule disabled={isLoading} isFor="email" formUpdated={formUpdated} formState={formState} ></SignModule>
              <SignModule disabled={isLoading} isFor="password" formUpdated={formUpdated} formState={formState} ></SignModule>
              {
                AuthType === 'SignUp' ?
                  <div className="sign-module">
                    <label className="sign-label" htmlFor="location">Location</label>
                    <div>
                      <LocationSelect
                        onFinal={formUpdated}
                        _countryID={formState?.location?._countryID}
                        _stateID={formState?.location?._stateID}
                        _cityID={formState?.location?._cityID}
                      ></LocationSelect></div></div> : null
              }
              {
                isLoading ? null :
                  <input type="Submit" onChange={() => { }} className="btn sign primary clickable" value={AuthType}></input>
              }
            </form> : null
        }
        {
          isLoading ? <Loading style={{ marginTop: "1rem" }} bright></Loading> : null
        }



        {/* <p>Before we begin, select a Prayer times calculation method and your location</p> */}

        {/* <select onChange={formUpdated} value={formState.calcMethod} name="calcMethod">
          {options.map((option, i) => <option value={i}>{option}</option>)}
        </select>

        <LocationSelect onFinal={formUpdated}></LocationSelect>

        {(formState.location) ? <button className="btn primary clickable" onClick={() => register(dispatch, formState)}>Save</button> : null} */}
      </div>
    </div>
  )
}
